import { render } from "./RegisterHitchHiking.view.vue?vue&type=template&id=f065073e"
import script from "./RegisterHitchHiking.view.vue?vue&type=script&lang=js"
export * from "./RegisterHitchHiking.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__